import type {
  CelebrationEmailTemplate, SaveCelebrationEmailTemplate, CreateInvitationBatch,
  InvitationBatch, InvitationBatchDetail,
} from '@om/shared-types';
import { apiClient } from './client';

interface Envelope<T> { success: true; data: T }
const root = (celebrationId: number) => `/celebrations/${celebrationId}`;

export const invitationWorkspaceService = {
  async listTemplates(celebrationId: number): Promise<CelebrationEmailTemplate[]> {
    return (await apiClient.get<Envelope<CelebrationEmailTemplate[]>>(`${root(celebrationId)}/email-templates`)).data.data;
  },
  async createTemplate(celebrationId: number, input: SaveCelebrationEmailTemplate): Promise<CelebrationEmailTemplate> {
    return (await apiClient.post<Envelope<CelebrationEmailTemplate>>(`${root(celebrationId)}/email-templates`, input)).data.data;
  },
  async updateTemplate(celebrationId: number, templateId: number, input: SaveCelebrationEmailTemplate): Promise<CelebrationEmailTemplate> {
    return (await apiClient.put<Envelope<CelebrationEmailTemplate>>(`${root(celebrationId)}/email-templates/${templateId}`, input)).data.data;
  },
  async deleteTemplate(celebrationId: number, templateId: number): Promise<null> {
    return (await apiClient.delete<Envelope<null>>(`${root(celebrationId)}/email-templates/${templateId}`)).data.data;
  },
  async listBatches(celebrationId: number): Promise<InvitationBatch[]> {
    return (await apiClient.get<Envelope<InvitationBatch[]>>(`${root(celebrationId)}/invitation-batches`)).data.data;
  },
  async createBatch(celebrationId: number, input: CreateInvitationBatch): Promise<InvitationBatch> {
    return (await apiClient.post<Envelope<InvitationBatch>>(`${root(celebrationId)}/invitation-batches`, input)).data.data;
  },
  async getBatch(celebrationId: number, batchId: number): Promise<InvitationBatchDetail> {
    return (await apiClient.get<Envelope<InvitationBatchDetail>>(`${root(celebrationId)}/invitation-batches/${batchId}`)).data.data;
  },
  async sendBatch(celebrationId: number, batchId: number): Promise<InvitationBatch> {
    return (await apiClient.post<Envelope<InvitationBatch>>(`${root(celebrationId)}/invitation-batches/${batchId}/send`)).data.data;
  },
  async cancelBatch(celebrationId: number, batchId: number): Promise<InvitationBatch> {
    return (await apiClient.post<Envelope<InvitationBatch>>(`${root(celebrationId)}/invitation-batches/${batchId}/cancel`)).data.data;
  },
};